<template>
  <action-dispatcher action="sale/get" :parameters="{ ...filters }">
    <div class="view-sales-coproducer-index">
      <h1 class="page-title">
        Relatório de receitas
        <small>
          Visualize a receita gerada no período selecionado.
        </small>
      </h1>
      <div
        v-if="!sales.length"
        class="container centralize-row text-center pt-9"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-9 mx-auto"
              src="@/assets/images/home/welcome.png"
            />
            <h5>Você ainda não realizou vendas!</h5>
            <div class="text-secondary mb-9">
              Após configurar seu produto, comece enviando o link de divulgação
              para seus clientes
            </div>

            <router-link class="btn btn-primary" :to="{ name: 'product' }">
              Visualizar Produtos
            </router-link>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row my-6">
          <div class="col-lg-8">
            <div class="d-flex align-items-center ">
              <h6 class="mr-6 d-lg-none">
                Receitas no período
              </h6>
              <h5 class="mr-6 d-none d-lg-block">
                Receitas no período
              </h5>
              <button
                class="btn btn-sm btn-outline-primary btn-square-sm p-5"
                @click="refresh"
              >
                <i class="icon-refresh-ccw" />
              </button>
            </div>
          </div>
        </div>
        <sale-line-chart
          :externalLoading="loading"
          @change-product="onChangeProduct"
          @change-currency="onChangeCurrency"
          @change-dates="onChangeDates"
        />
        <div class="row py-6">
          <div class="col-lg-4 py-3">
            <total :refresh="loading" />
          </div>
          <div class="col-lg-4 py-3">
            <card>
              <h6 class="mb-5">Quantidade de vendas</h6>
              <h5 class="text-dark">{{ pagination.count }}</h5>
            </card>
          </div>
          <div class="col-lg-4 py-3">
            <total-comission-card :refresh="loading" />
          </div>
        </div>
        <div v-if="loading" class="text-center">
          <b-spinner variant="primary" />
        </div>
        <div v-else>
          <!-- mobile area start -->
          <data-table
            class="d-lg-none"
            :columns="responsive.mobileColumns"
            :data="sales"
            :showSeparator="false"
            :firstColumnFr="2.7"
            :lastColumnFr="0.3"
          >
            <template #default="{ item }">
              <div class="p-5 d-flex flex-column">
                <small class="mb-2">
                  <strong>Período: </strong>{{ item.created_at | formatDate }}
                </small>
                <small class="mb-2">
                  <strong>Produto: </strong>{{ item.product_name }}
                </small>
                <!-- <small class="mb-2">
                  <strong>Quantidade de Vendas:</strong> {{ item.sales_count }}
                </small> -->
                <small class="mb-2">
                  <strong>Receita: </strong>R$ {{ item.amount }}
                </small>
              </div>
              <div></div>
            </template>
          </data-table>
          <!-- mobile area  end-->
          <!-- desktop area  start-->
          <data-table
            class="d-none d-lg-block"
            :columns="responsive.columns"
            :data="sales"
            :showSeparator="false"
            :firstColumnFr="1"
            :lastColumnFr="0.5"
          >
            <template #default="{ item }">
              <small class="d-flex align-items-center pl-3">
                {{ item.created_at | formatDate }}
              </small>
              <small class="pr-2 d-flex align-items-center">{{
                item.product_name
              }}</small>
              <!-- <small
                class="pr-2 d-flex align-items-center"

                >{{ item.sales_count }}
              </small> -->
              <small class="d-flex align-items-center"
                >R$ {{ item.amount }}
              </small>
            </template>
          </data-table>
          <!-- desktop area end-->
        </div>
        <div class="d-flex justify-content-center">
          <paginator :pagination="pagination" @on-update="onPaginationUpdate" />
        </div>
        <responsive-modal v-if="focusedSale" size="lg" v-model="modal.details">
          <sale-detail :sale_id="focusedSale.id" />
        </responsive-modal>
      </div>
    </div>
  </action-dispatcher>
</template>
<script>
import SaleLineChart from "@/components/reports/SaleLineChart.vue";
import SaleDetail from "@/components/sale/Details.vue";
import Total from "@/components/sale/TotalCard.vue";
import TotalComissionCard from "@/components/sale/TotalComissionCard.vue";
import { clearObject } from "@/functions/helpers";
import SaleMixin from "@/mixins/sale";
import { mapState } from "vuex";

export default {
  mixins: [SaleMixin],
  components: { SaleDetail, Total, SaleLineChart, TotalComissionCard },
  data() {
    return {
      loading: false,
      focusedSale: null,
      modal: {
        details: false
      },
      filters: {
        status: "paid, completed",
        payment_process: "",
        paid_at_after: "",
        paid_at_before: ""
      },
      responsive: {
        mobileColumns: ["", ""],
        // columns: ["Período", "Produto", "Quantidade de Vendas", "Receita"],
        columns: ["Período", "Produto", "Receita"],
        actions: [
          {
            text: "Detalhes",
            class: "",
            icon: "icon-exclamation-outline",
            confirmation: {
              enable: false,
              text: ""
            },
            event: "open-details"
          }
        ]
      }
    };
  },
  watch: {
    "modal.details"(val) {
      if (!val) {
        this.focusedSale = null;
      }
    },
    filters: {
      deep: true,
      handler() {
        this.refresh();
      }
    }
  },
  computed: {
    ...mapState("sale", ["sales", "pagination"]),
    ...mapState("product", ["product", "products"])
  },
  methods: {
    refresh() {
      this.loading = true;
      const params = {
        ...this.filters
      };
      this.$store
        .dispatch("sale/get", clearObject(params))
        .then()
        .finally(() => {
          this.loading = false;
        });
    },
    onPaginationUpdate(offset) {
      let filters = { ...this.filters };
      if (filters.product_id === "all") {
        delete filters.product_id;
      }
      this.$store
        .dispatch("sale/get", clearObject({ offset, ...filters }))
        .then()
        .finally(() => {
          this.loading = false;
        });
    },
    openDetail(item) {
      this.focusedSale = item;
      this.modal.details = true;
    },
    exportData() {},
    onChangeProduct(product_id) {
      this.filters.product_id = product_id;
    },
    onChangeCurrency(currency_id) {},
    onChangeDates(dates_range) {
      this.filters.paid_at_after = dates_range[0];
      this.filters.paid_at_before = dates_range[1];
    }
  }
};
</script>
<style lang="scss" scoped>
.view-sales-coproducer-index {
  .btn-outline-warning {
    min-height: 20px;
  }
}
</style>
